export const CONSTANTS = Object.freeze({
    STRIPE_PUBLIC_KEY: 'pk_test_8lLXOcWvlW3w134ZiXG5ARd7003pW4sklZ',
    APPLICATION_WEB_URL: 'http://localhost:8080'
})
  